/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { useLocation, Link } from "react-router-dom";
import { Navigation } from "@nordcloud/gnui";
import { ROUTES } from "~/routing/routes";

function BusinessMenu() {
  const location = useLocation();
  const isActive = (check: string) => location.pathname === check;
  const params = (to: string) => ({
    as: Link,
    to,
    className: `hasBg ${isActive(to) && "active"}`,
  });
  const names = ["Organization Unit Types"];
  const links = [ROUTES.business.unitTypes];
  return (
    <Navigation.Container secondary>
      {links.map((link, index) => (
        <Navigation.Item key={link} {...params(link)}>
          {names[index]}
        </Navigation.Item>
      ))}
    </Navigation.Container>
  );
}

export default BusinessMenu;
